import React from 'react';
import usePrefersReducedMotion from '../../../../hooks/usePrefersReducedMotion';
import * as css from './AiAgentMedia.css';

interface AiAgentMediaProps {
    src: string;
    poster: string;
}

/**
 * The agent's animated mark. Under prefers-reduced-motion the looping video is replaced by
 * its still poster frame, so nothing animated is fetched or played at all — the video is
 * ~2.3MB, which is also why it preloads metadata only.
 */
function AiAgentMedia({src, poster}: AiAgentMediaProps) {
    const prefersReducedMotion = usePrefersReducedMotion();

    if(prefersReducedMotion) {
        return <css.media as="img" src={poster} alt="" />;
    }

    return (
        <css.media
            src={src}
            poster={poster}
            preload="metadata"
            autoPlay
            muted
            loop
            playsInline
            aria-hidden
        />
    );
}

export default AiAgentMedia;
